import { render, staticRenderFns } from "./BridgeVideoPanel.vue?vue&type=template&id=090ce8d7&scoped=true"
import script from "./BridgeVideoPanel.vue?vue&type=script&lang=js"
export * from "./BridgeVideoPanel.vue?vue&type=script&lang=js"
import style0 from "./BridgeVideoPanel.vue?vue&type=style&index=0&id=090ce8d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ce8d7",
  null
  
)

export default component.exports